var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-close",
    transform: "translate(1744 -79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 37,
    height: 37,
    transform: "translate(-1744 79)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(-1725.5 72.401) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M17.748,7.875a1.1,1.1,0,0,1,1.1,1.1v8.776a1.1,1.1,0,0,1-1.1,1.1H8.972a1.1,1.1,0,1,1,0-2.194h7.679V8.972A1.1,1.1,0,0,1,17.748,7.875Z",
    transform: "translate(0 0)",
    fill: "#013871",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M16.875,17.972a1.1,1.1,0,0,1,1.1-1.1h8.776a1.1,1.1,0,0,1,0,2.194H19.069v7.679a1.1,1.1,0,0,1-2.194,0Z",
    transform: "translate(-0.224 -0.224)",
    fill: "#013871",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.0aeab0cd5e073a567f771b43a78b2e00.svg";
export { ForwardRef as ReactComponent };